import { Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

function PageTransition() {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState('enter');

  useEffect(() => {
    if (location !== displayLocation) {
      setTransitionStage('exit');
    }
  }, [location, displayLocation]);

  useEffect(() => {
    if (transitionStage === 'exit') {
      const timer = setTimeout(() => {
        setDisplayLocation(location);
        setTransitionStage('enter');
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [transitionStage, location]);

  return (
    <div
      className={`page-transition-wrapper ${
        transitionStage === 'enter' ? 'fade-in' : 'fade-out'
      }`}
    >
      <Outlet />
    </div>
  );
}

export default PageTransition;
